import { useTranslation } from 'react-i18next';
import { Lightbulb } from 'lucide-react';
import { helpFor, pickLang } from '@/lib/agentHelp';

/**
 * A subtle "how this works" line under an agent page's title. One sentence,
 * localized (EN/JA shipped, English fallback), telling a first-timer what to do.
 */
export function HelpHint({ page }: { page: string }) {
  const { i18n } = useTranslation();
  const entry = helpFor(page);
  if (!entry) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg bg-accent-50/60 border border-accent-100 px-3 py-2 text-[12.5px] text-ink-700">
      <Lightbulb size={15} className="text-accent-600 shrink-0 mt-0.5" />
      <span className="leading-relaxed">{pickLang(entry.tip, i18n.language)}</span>
    </div>
  );
}
